import { jsx as x } from "react/jsx-runtime";
import { useRef as N, useMemo as w, useEffect as R, useCallback as O } from "react";
import S from "../../../../merge-refs/dist/esm/index.es.js";
import b from "../../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import T from "../../../../warning/warning.es.js";
import { AnnotationMode as j } from "../../../node_modules/pdfjs-dist/build/pdf.es.js";
import B from "../StructTree.es.js";
import L from "../shared/hooks/usePageContext.es.js";
import { getDevicePixelRatio as V, cancelRunningTask as $, makePageCallback as D, isCancelException as F } from "../shared/utils.es.js";
const E = j;
function W(l) {
  const d = L();
  b(d, "Unable to find Page context.");
  const C = Object.assign(Object.assign({}, d), l), { _className: _, canvasBackground: i, devicePixelRatio: f = V(), onRenderError: p, onRenderSuccess: u, page: e, renderForms: m, renderTextLayer: k, rotate: r, scale: o } = C, { canvasRef: y } = l;
  b(e, "Attempted to render page canvas, but no page was specified.");
  const s = N(null);
  function P() {
    e && u && u(D(e, o));
  }
  function M(t) {
    F(t) || (T(!1, t.toString()), p && p(t));
  }
  const a = w(() => e.getViewport({ scale: o * f, rotation: r }), [f, e, r, o]), c = w(() => e.getViewport({ scale: o, rotation: r }), [e, r, o]);
  R(function() {
    if (!e)
      return;
    e.cleanup();
    const { current: n } = s;
    if (!n)
      return;
    n.width = a.width, n.height = a.height, n.style.width = `${Math.floor(c.width)}px`, n.style.height = `${Math.floor(c.height)}px`, n.style.visibility = "hidden";
    const h = {
      annotationMode: m ? E.ENABLE_FORMS : E.ENABLE,
      canvasContext: n.getContext("2d", { alpha: !1 }),
      viewport: a
    };
    i && (h.background = i);
    const v = e.render(h), A = v;
    return v.promise.then(() => {
      n.style.visibility = "", P();
    }).catch(M), () => $(A);
  }, [i, e, m, a, c]);
  const g = O(() => {
    const { current: t } = s;
    t && (t.width = 0, t.height = 0);
  }, []);
  return R(() => g, [g]), x("canvas", { className: `${_}__canvas`, dir: "ltr", ref: S(y, s), style: {
    display: "block",
    userSelect: "none"
  }, children: k ? x(B, {}) : null });
}
export {
  W as default
};
//# sourceMappingURL=Canvas.es.js.map
